const markerIconSize = 24;

export default markerIconSize;
